export const ACCEPTED_REQUIREMENT_FOR_BENEFIT_SUCCESS = "Wykonano operacje";
export const ACCEPTED_REQUIREMENT_FOR_BENEFIT_FAILURE =
  "Wystąpił nieoczekiwany błąd";

export const REJECT_BENEFIT_SUCCESS = "Wykonano operacje";
export const REJECT_BENEFIT_FAILURE = "Wystąpił nieoczekiwany błąd";

export const conditionTypesOptions = [
  {
    value: "DOCUMENT_REQUIRED",
    label: "Akceptacja dokumentu potrącenia z wynagrodzenia",
  },
  {
    value: ["ACCEPT_ONLY", "AHR_ACCEPTANCE_REQUIRED"],
    label: "Akceptacja przez AHR",
  },
  // Hidden only in filter
  // { value: "BARCODE", label: "Dokument z kodem kreskowym" },
  { value: "EMPLOYEE_REQUIRED", label: "Oczekuje na osobę główną" },
  {
    value: ["PARENT_REQUIRED_AUTO", "WAITING_FOR_PARENT"],
    label: "Oczekuje na świadczenie główne",
  },
  { value: "ACTIVE_FORM", label: "Oczekuje na uzupełnienie danych" },
  // Hidden only in filter
  // {
  //   value: "SIGNED_DOCUMENT_REQUIRED",
  //   label: "Wymagany podpisany dokument e\u2011podpisem",
  // },
  { value: "FINANCING_CHANGE_REQUIRED", label: "Zmiana finansowania" },
];
